import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    holder: {
      display: 'flex'
    },
    topLabel: {
      paddingTop: componentTheme.bottomLabelPadding
    },
    bottomLabel: {
      paddingTop: componentTheme.bottomLabelPadding
    },
    choicesWrapper: _objectSpread({
      flexBasis: '25rem',
      marginTop: componentTheme.choicesWrapperMargin
    }, props.properties.displayAnswersParagraph && {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column'
    }),
    feedbackWrapper: {
      marginLeft: componentTheme.feedbackWrapperMargin,
      marginBottom: componentTheme.feedbackWrapperMarginBottom
    },
    userResponse: {
      minWidth: '5rem'
    }
  };
};
export default generateStyle;